<template>
  <div class="page_msg container">
    <div class="header_gruop page_width flex_sb">
      <div class="icon_home flex_center" @click="toBack()"><svg t="1729563443244" class="icon" viewBox="0 0 1024 1024"
          version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6080" id="mx_n_1729563443245" width="16" height="16">
          <path
            d="M398.912 513.152l377.28-384.256c27.904-28.416 27.904-74.432 0-102.784-27.84-28.352-73.024-28.352-100.8 0L247.808 461.504C233.792 475.776 226.88 494.464 226.944 513.152 226.88 531.84 233.792 550.464 247.808 564.736l427.584 435.392c27.84 28.352 73.024 28.352 100.8 0 27.904-28.352 27.904-74.368 0-102.656L398.912 513.152z"
            fill="#16181c" p-id="6081"></path>
        </svg></div>
      <div class="header_title">Terms of Use</div>
      <div></div>
    </div>

    <div class="scoller grid_content" :v-infinite-scroll="false" style="overflow:auto">
      <div class="service page_width">
        <p>Terms of Use</p>
        <p> <strong>Welcome to the jndplayhub platform, which is legally owned and operated by Jumman Nur For Documents Clearing Services L.L.C S.O.C. The company address is IBRAHIM HUSSAIN AHLI - 101, Al Muteena, Deira ,Dubai,UAE.</strong> </p>
        <p>Jndplayhub is a game recharge website. By creating an account and accessing the platform, you agree to
          abide by these terms of use.</p>


        <p>Modification of Terms</p>
        <p>We reserve the right to modify or update these Terms of Use at any time. Any changes to these Terms will be
          posted on the Platform and, if necessary, communicated to you via email. Your continued access to and use of
          the Platform after such updates will constitute your acceptance of the revised Terms. Please check the Terms
          regularly for updates.</p>
        <p style="font-weight: bold;">1. Definitions</p>
        <p>Account: Refers to the registered user account created on the Platform to access Services.</p>
        <p>Buyer: The individual purchasing items on the Platform.</p>
        <!-- <p>Gift Card: An electronic card purchased on the Platform containing stored value redeemable on the Platform.</p> -->
        <!-- <p>CD Key: An electronic code used to activate a game.</p> -->
        <p>Content: All information, data, text, images, videos, and materials available on the Platform.</p>
        <p>Intellectual Property: Includes copyrights, trademarks, and other proprietary rights held by their respective
          owners or by jndplayhub.</p>
        <!-- <p>Platform: Refers collectively to the jndplayhub website, Android app, iOS app, and any affiliated web services.</p> -->
        <p>Purchased Items: Items listed and bought by the Buyer on the Platform.</p>
        <!-- <p>Credits: Digital credits acquired by Buyers for use in purchasing goods and services on the Platform.</p> -->
        <!-- <p>Points: Points awarded for activities on the Platform, as defined by jndplayhub.</p> -->
        <p>Service(s): Refers to the services provided on the Platform, including digital goods sales and any content or
          resources available via the Platform.</p>
        <!-- <p>Service(s): Refers to the services provided on the Platform, including digital goods sales and any content or
          resources available via the Platform.</p> -->
        <p>User ID: The unique identifier assigned to your account upon registration.</p>
        <p style="font-weight: bold;">2. License of Use</p>
        <p>Upon your acceptance of and adherence to these Terms of Use, jndplayhub grants you a non-exclusive,
          non-transferable license to access and use the Platform and Services as described herein.</p>
        <p style="font-weight: bold;">3. Representations and Warranties</p>
        <p>Each time you use the Platform, you represent and warrant that you are of legal age. If you are a minor,
          jndplayhub assumes you have obtained consent from a parent or guardian who agrees to these Terms on your
          behalf.</p>
        <p>You agree to keep your account information secure, refrain from disclosing your password to unauthorized
          third parties, and promptly notify jndplayhub of any security breaches.
          You agree not to:</p>
        <p>Misrepresent your identity or affiliation on the Platform.</p>
        <p>Use the Platform for any illegal, unauthorized, or harmful activities.</p>
        <p>Use sojplayhub’s intellectual property without prior written consent.</p>
        <p>Engage in disruptive, harmful, or disrespectful behavior towards other users or jndplayhub personnel.</p>
        <p>Attempt to hack or circumvent security features on the Platform.</p>
        <p>Collect or harvest information from other users without their consent.</p>
        <p style="font-weight: bold;">4. Account ID</p>
        <p>To access certain Platform features, you may need to create an account by providing accurate personal
          information. You agree to update your information as necessary to keep it current. If any inaccurate
          information is provided, jndplayhub reserves the right to suspend or terminate your account.</p>
        <p style="font-weight: bold;">5. Use of the Services</p>
        <p>You are responsible for securing and maintaining any hardware, software, or other tools needed to access the
          Platform. You are solely responsible for understanding and adhering to the policies governing the use of
          Services provided by jndplayhub</p>
        <p>You acknowledge that any actions taken via your account will be considered as requested by you. jndplayhub
          is not responsible for verifying the authority of the account user or the authenticity of such requests.</p>
        <!-- <p>6. Goods and Services</p>
        <p>All items on the Platform are presented on a non-exclusive, revocable basis. Points or credits reflected in
          your account have no real-world monetary value and cannot be redeemed for cash.</p> -->
        <p style="font-weight: bold;">6. Availability of Services</p>
        <p>Jndplayhub may introduce new or beta features that may not perform as expected. </p>
        <p>Jndplayhub may also require identity verification to ensure security and compliance.</p>
        <p>Accounts inactive for a continuous 12-month period may be subject to a service fee.</p>
        <p style="font-weight: bold;">7. Disclaimer of Liability</p>
        <p>Jndplayhub provides the Platform “as-is” and “as available” without any warranties, express or implied,
          including but not limited to fitness for a particular purpose. To the fullest extent permissible by law,
          jndplayhub disclaims all liability for any indirect, consequential, or incidental damages arising from the
          use of the Platform or Services.</p>
        <p style="font-weight: bold;">8. Intellectual Property Rights</p>
        <p>All proprietary content on the Platform is the exclusive property of jndplayhub or respective third
          parties. No rights are granted to you to use, reproduce, or distribute such content without permission.</p>
        <p>Any submissions you make may be used by jndplayhub without obligation or compensation to you. By submitting
          content, you grant jndplayhub a perpetual, non-exclusive, royalty-free license to use, distribute, and
          modify your content for any purpose.</p>
        <p style="font-weight: bold;">9. Platform Reliability</p>
        <p>You acknowledge that network and telecommunications issues may affect your ability to access the Platform.
          jndplayhub is not responsible for delays or errors in notifications or confirmations sent via the Platform.
        </p>
        <p style="font-weight: bold;">10. Account Security</p>
        <p>You agree to promptly notify jndplayhub of any unauthorized access or use of your account. You are
          responsible for all actions taken through your account prior to such notice.</p>
        <p style="font-weight: bold;">11. Disclosure of Information</p>
        <p>Jndplayhub reserves the right to disclose information related to your account if required by law or as
          deemed necessary to enforce these Terms of Use.</p>
        <p style="font-weight: bold;">12. Indemnification</p>
        <p>You agree to indemnify and hold jndplayhub and its affiliates harmless from any claims arising out of your
          breach of these Terms, your misuse of the Platform, or your violation of any third-party rights.</p>
        <p style="font-weight: bold;">13. Account Suspension or Termination</p>
        <p>Jndplayhub reserves the right to suspend or terminate your account at any time for reasons including, but
          not limited to, suspected fraud, unauthorized account sharing, or violations of these Terms of Use.</p>
        <p>If you wish to deactivate your account, you may contact jndplayhub.</p>
        <p style="font-weight: bold;">14. Governing Law</p>
        <p style="margin-bottom:40px;">These Terms and Conditions, as well as any separate agreements under which we
          provide services to you, shall be governed by and construed in accordance with local law.</p>
        <!-- <p>16. Refund Policy</p>
        <p>Any game top up that have been credited is final.</p>
        <p>If customer have entered the wrong login credentials/player id to top up, jndplayhub may notify customer
          via </p>
        <p>nithinxyz7@gmail.com</p>
        <p> for correction, but once the order is delivered, no refunds can be given.</p>
        <p>Bonus top up is given by the game authority, no refunds can be given if bonus top up is not credited to your
          account.</p>
        <p>To be eligible for a return:Unauthorized charged on your credit/debit card, Paypal or any other payment
          methods and your order must not be delivered</p>
        <p>We are unable to fulfill your order due to the lack of stock or unable to deliver your items due to the item
          is not available anymore.</p>
        <p>To complete your return, please contact our Customer Support Live-Chat or through email to </p>
        <p>nithinxyz7@gmail.com</p>
        <p> We require a receipt or proof of purchase in jndplayhub for the payment to be refunded.</p>
        <p>Refunds (if applicable):If your purchase is eligible for refunds, please contact our Customer Support through
          email to nithinxyz7@gmail.com</p>
        <p>Late or missing refunds (if applicable):If you haven’t received a refund yet, please check your payment
          accounts again.</p>
        <p>Then contact your credit card company, it may take some time before your refund is officially posted.</p>
        <p>Next contact your bank. There is often some processing time before a refund is posted.</p>
        <p>If you’ve done all of this and you still have not received your refund yet, please contact us at </p>
        <p style="margin-bottom:40px;">nithinxyz7@gmail.com</p> -->

        <!-- <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p> -->

      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toBack() {
      this.$router.back()
    }
  }
}
</script>

<style></style>